// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1z938","inputWrap":"Table_inputWrap__284PD","col":"Table_col__NJVpt","bmiTooltip":"Table_bmiTooltip__3McIO"};